import React from 'react'
import IcoBlank from 'react-icons/lib/io/social-dropbox-outline'

const Nodata = () => (
  <div className="nodata">
    <IcoBlank />
    <p>見つかりませんでした</p>
  </div>
)

export default Nodata



// WEBPACK FOOTER //
// ./src/components/Nodata.jsx